import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../context/ThemeContext';

function About() {
  const { theme } = useTheme();
  const tokens = theme.tokens;
  const tc = tokens.colors;

  const cardStyle = {
    background: `color-mix(in srgb, ${tc.surface} 75%, transparent)`,
    backdropFilter: 'blur(2px)',
    WebkitBackdropFilter: 'blur(6px)',
    border: `1px solid ${tc.gridLine}`,
    borderRadius: 14,
    padding: '32px 36px',
    marginTop: 24,
  };

  const h1Style = {
    fontFamily: tokens.fonts.display,
    fontSize: 'clamp(24px, 5vw, 32px)',
    fontWeight: 600,
    color: tc.ink,
    marginBottom: 20,
    lineHeight: 1.2,
  };

  const h2Style = {
    fontFamily: tokens.fonts.display,
    fontSize: 20,
    fontWeight: 600,
    color: tc.ink,
    marginTop: 28,
    marginBottom: 10,
  };

  const linkStyle = { color: tc.accent };

  return (
    <div className="container mx-auto px-4 sm:px-8 pb-12" style={{ color: tc.muted, fontFamily: tokens.fonts.ui, textAlign: 'left' }}>
      <Helmet>
        <title>About ATLTech.events — Atlanta's Tech Event Calendar</title>
        <meta name="description" content="How ATLTech.events finds, curates, and lists Atlanta tech meetups and events, how to submit an event, and how to bring the platform to your city." />
      </Helmet>
      <div style={cardStyle}>
        <h1 style={h1Style}>About ATLTech<span style={{ color: tc.accent, fontFamily: theme.tokens.fonts.ui }}>.events</span><sup>SM</sup></h1>

        <div className="space-y-4">
          <p>
            Welcome to the Beta version of ATLTech.events. This is a work in progress and we are always looking for feedback.
          </p>
          <p>
            ATLTech.events is your comprehensive resource for discovering and keeping track of
            technology-related events in the greater Atlanta area. Our platform serves as a central hub
            for the tech community, bringing together events from various organizations and groups.
          </p>
          <p>
            Our mission is to foster connection and growth within Atlanta's tech ecosystem by making
            it easier for professionals, enthusiasts, and newcomers to find and participate in relevant
            tech events.
          </p>

          <h2 style={h2Style}>How it works</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Any publicly available event we know about in the technology or technology-related space is added to the calendar. While our focus is in-person events, we may include some virtual events hosted by local organizations. Members-only events are generally not added, but exceptions are made when guests are permitted or the group sponsors the event listing.</li>
            <li>Private, invite-only commercial events are not added, but can be added as a sponsored event for a small fee.</li>
            <li>We offer advertising and sponsorship opportunities to organizations that want to reach the tech community.</li>
            <li>Have an event to add? <a target="_blank" rel="noopener noreferrer" style={linkStyle} className="hover:underline" href="https://forms.office.com/pages/responsepage.aspx?id=qzlC4RQKwUSrZA2o3JP4xv4WR-vse95Kv42iNLzgdQtUOVVPU1FRTkFJUEpTR0s5VzhOMENOTEpWNC4u&route=shorturl">Submit an event!</a></li>
            <li>To recommend an event or organization, correct any event information, learn about sponsoring or advertising, or add a private event, please contact us at <a target="_blank" rel="noopener noreferrer" style={linkStyle} className="hover:underline" href="https://www.linkedin.com/company/atl-tech-events">ATLTech.events on LinkedIn</a>.</li>
          </ul>

          <h2 style={h2Style}>What about my city?</h2>
          <p>
            The platform is built to be easily customizable to other cities. If you are interested in leveraging the platform for your city, please contact us at <a target="_blank" rel="noopener noreferrer" style={linkStyle} className="hover:underline" href="https://www.linkedin.com/company/atl-tech-events">ATLTech.events on LinkedIn</a>.
          </p>

          <h2 style={h2Style}>Event Horizon Media<sup>SM</sup></h2>
          <p className="flex justify-center">
            <img src="event-horizon-media-logo.png" alt="Event Horizon Media Logo" className="w-1/2 rounded-full" />
          </p>
          <p>
            Event Horizon Media is a media and event platform service of Mirability, LLC, that produces the ATLTech.events calendar and newsletter. Want to see the platform in your city? Let us know!
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
